import log from 'loglevel'
import axios from 'axios'

import Cache from '../../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class Account {
  constructor() {
    log.info('[INFO] Initialize Account Module')
    this.cache = new Cache()
  }

  fetchAccountList(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/accounts/account-list/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch Accounts')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch Accounts')
            log.error(error)
            reject(error.response)
          })
      })
      return promise
    })
    return result
  }

  fetchAccountSelectList(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params,
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/accounts/account-select/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch Accounts')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch Accounts')
            log.error(error)
            reject(error.response)
          })
      })
      return promise
    })
    return result
  }

  fetchAccount(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/accounts/account/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch Account')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch Account')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateAccount(id, administratorData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/accounts/account/${id}/`, administratorData)
        .then(response => {
          log.debug('[DEBUG] Success to update Account')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update Account')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addAccount(administratorData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/accounts/account/', administratorData)
        .then(response => {
          log.debug('[DEBUG] Success to add Account')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add Account')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteAccount(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/accounts/account/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete Account')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete Account')
          log.error(error)
          reject(error.response)
        })
    })
  }

  fetchContextAccount(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/accounts/user/account/context-name/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch Context Account')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch Context Account')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateContextAccount(id, contextAccount) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/accounts/user/account/context/${id}/`, contextAccount)
        .then(response => {
          log.debug('[DEBUG] Success to update Context Account')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update Context Account')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
